import { compact } from 'lodash';
import { useMemo } from 'react';

import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { useEntityDetailsContext } from '@/modules/entities/contexts/entityDetails/entityDetails.context';
import { BeneficiaryLevel } from '@/types/schema';

import { isCurrentBeneficiaryEntityKind } from '../entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform.constants';
import {
  BENEFICIARY_LEVEL_CURRENT_ACCESS_DISPLAY_NAMES,
  BENEFICIARY_LEVELS,
} from './beneficiaries.constants';

export function useIsCurrentBeneficiaryEntity(): boolean {
  const { entityKind } = useEntityDetailsContext();
  return useMemo<boolean>(() => {
    return isCurrentBeneficiaryEntityKind(entityKind);
  }, [entityKind]);
}

export function useBeneficiaryLevelItems(): SelectInputOption<BeneficiaryLevel>[] {
  return useMemo<SelectInputOption<BeneficiaryLevel>[]>(() => {
    const displaySource = BENEFICIARY_LEVEL_CURRENT_ACCESS_DISPLAY_NAMES;

    return compact(
      BENEFICIARY_LEVELS.map((value) => {
        const display = displaySource[value];
        if (!display) return null;

        return {
          display,
          value,
        };
      })
    );
  }, []);
}
